import { Divider, Group } from '@mantine/core'
import { Badge, Stack, Text } from 'components'
import { useArcTranslation } from 'hooks'
import type { FrameworkItem } from './types'
import { TrackerScore } from './TrackerScore'

interface TrackerStackedListProps {
  readonly items: readonly FrameworkItem[]
}

export const TrackerStackedList = ({ items }: TrackerStackedListProps) => {
  const { t } = useArcTranslation()
  const tooltip = t('arc_development_tracker.score_tooltip')

  return (
    <Stack spacing='md'>
      {items.map((item, index) => (
        <Stack key={item.id} spacing={6}>
          {item.lv1Name && (
            <Badge
              variant='filled'
              radius='sm'
              size='sm'
              sx={{
                alignSelf: 'flex-start',
                backgroundColor: item.color || '#7DCEA0',
                color: '#fff',
                textTransform: 'uppercase',
              }}
            >
              {item.lv1Name}
            </Badge>
          )}
          {item.breadcrumb && (
            <Text size='xs' color='dimmed'>
              {item.breadcrumb}
            </Text>
          )}
          <Group position='apart' align='flex-start' noWrap>
            <Text size='sm' sx={{ flex: 1 }}>
              {item.originalCodes && <strong>{item.originalCodes}</strong>}
              {item.originalCodes && item.name ? ' — ' : ''}
              {item.name}
            </Text>
            <TrackerScore score={item.assessmentAverage} tooltip={tooltip} />
          </Group>
          {index < items.length - 1 && <Divider mt='sm' />}
        </Stack>
      ))}
    </Stack>
  )
}
